import { Component, Output, EventEmitter, Input } from '@angular/core';
import { PortalApiService } from '../../../../_services/portal-api.service';
import { RunTicket } from '../../../../_models/field';

@Component({
  selector: 'app-import-tickets',
  templateUrl: './import-tickets.component.html',
  styleUrls: ['./import-tickets.component.css']
})
export class ImportTicketsComponent {
  @Input() fieldID: number;
  @Output() ticketsCreated = new EventEmitter<RunTicket[]>();
  errorTickets: RunTicket[] = [];
  successTickets: RunTicket[] = [];
  failedTickets: RunTicket[] = [];
  isDownloadingTemplate: boolean = false;
  isUploadingFiles: boolean = false;
  filesToUpload: FormData;
  fileUploadError: string = null;
  successCollapsed: boolean = true;
  failedCollapsed: boolean = true;
  conflictCollapsed: boolean = false;
  fileUploadCompleted: boolean = false;
  fileUploadSucceeded: boolean = false;
  visible: boolean = false;

  constructor(
    private apiService: PortalApiService,

  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  onImportBtn() {
    this.resetImportTickets();
    this.visible = true;
  }

  downloadTemplate() {
    const templateType = 'RunTickets';
    this.apiService.downloadRunTicketTemplate(templateType, this.fieldID).subscribe({
      next: (result: any) => {
        console.log(result);
        let objectURL = URL.createObjectURL(result);
        this.updateTemplateName(objectURL);
      },
      error: err => {
        console.log("error", err);
      }
    });
  }

  private updateTemplateName(url: string) {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = "RunTicketTemplate";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onUploadFiles(event) {
    this.resetImportTickets();
    this.successTickets = [];
    this.failedTickets = [];

    /*this.messageService.clear();*/
    this.isUploadingFiles = true;
    let formData: FormData = new FormData();
    for (let i = 0; i < event.files.length; i++) {
      formData.append(`file {i}`, event.files[i], event.files[i].name);
    }
    this.filesToUpload = formData;

    this.apiService.importRunTickets(this.filesToUpload).subscribe({
      next: (data: RunTicket[]) => {
        this.processImportedTickets(data);
        this.isUploadingFiles = false;
        this.fileUploadCompleted = true;
        this.fileUploadSucceeded = true;
      },
      error: err => {
        console.log(err);
        this.fileUploadError = (err.error || 'An error occurred while attempting upload the file. Please close this window and try again.');
        this.fileUploadCompleted = true;
        this.fileUploadSucceeded = false;
        this.isUploadingFiles = false;
      }
    });
  }

  private resetImportTickets() {
    this.fileUploadError = null;
    this.fileUploadCompleted = false;
    this.fileUploadSucceeded = false;
    this.successCollapsed = true;
    this.failedCollapsed = true;
    this.conflictCollapsed = false;
  }

  processImportedTickets(ticketResults: RunTicket[]) {
    const tankErrorKey = 'tankID';

    if (ticketResults.length > 0) {
      ticketResults.forEach(ticket => {
        /*if (ticket.errorComment.includes(tankErrorKey)) {
          ticket.errorComment = "Invalid tank or battery. Please correct tank or battery name.";
        }*/
        this.failedTickets.push(ticket);
      });
    }
  }
}
